import { render, staticRenderFns } from "./LinkReferenceWidget.vue?vue&type=template&id=4bed3ce6&scoped=true&"
import script from "./LinkReferenceWidget.vue?vue&type=script&lang=js&"
export * from "./LinkReferenceWidget.vue?vue&type=script&lang=js&"
import style0 from "./LinkReferenceWidget.vue?vue&type=style&index=0&id=4bed3ce6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bed3ce6",
  null
  
)

export default component.exports